// STORE DEPENDANCY
import { Action } from '@ngrx/store';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';

export enum ActionTypes {
  // Dashboard ACTIONS
  DASHBOARD_COMMON = '[Dashboard] Dashboard Common',
  DASHBOARD_COMMON_SUCCESS = '[Dashboard] Dashboard Common Success',
}

// -------------------------------
//  Dashboard Common
// -------------------------------
export class DashboardCommonAction implements Action {
  readonly type = ActionTypes.DASHBOARD_COMMON;
  constructor(public payload: ApiPayload) { }
}

// -------------------------------
//  Dashboard Common Success
// -------------------------------
export class DashboardCommonSuccessAction implements Action {
  readonly type = ActionTypes.DASHBOARD_COMMON_SUCCESS;
  constructor(public response?: any) { }
}


export type Actions =
  | DashboardCommonAction
  | DashboardCommonSuccessAction;

